<template>
  <nav class="navigation">
    <router-link
      v-for="page in pages"
      class="navigation__link"
      :to="page.homePage ? '/' : page.url"
      :key="page.id"
      :exact="page.homePage"
    >{{page.pageName}}</router-link>
  </nav>
</template>

<script>
export default {
  computed: {
    pages() {
      const pagesOrderedByCreated = this.$store.state.pages.reverse();
      return pagesOrderedByCreated;
    },
  },
};
</script>

<style scoped>
.navigation {
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.navigation__link {
  display: block;
  width: 50%;
  padding: 16px 16px;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--dark-purple);
  font-weight: 400;
}

.router-link-active {
  color: var(--dark-purple);
  font-weight: 700;
  background-color: var(--ten-darker);
}

@media screen and (min-width: 640px) {
  .navigation {
    margin-bottom: 0px;
    justify-content: flex-end;
  }
  .navigation__link {
    width: auto;
    padding: 8px 32px;
  }

  .router-link-active {
    border-bottom: 2px solid var(--dark-purple);
    background-color: transparent;
  }
}
</style>
